import { render, staticRenderFns } from "./ShopItemUsersView.vue?vue&type=template&id=172d89f0"
import script from "./ShopItemUsersView.vue?vue&type=script&lang=js"
export * from "./ShopItemUsersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports